import React, { useEffect, useState } from "react";
import { adminApi } from "../services/adminApi";
import Pagination from "../components/Pagination";

export default function TeamManagement() {
  const [query, setQuery] = useState("");
  const [data, setData] = useState(null);
  const [userList, setUserList] = useState([]);
  const [paging, setPaging] = useState({ page: 1, pageSize: 10, total: 0 });
  const [downlinePage, setDownlinePage] = useState(1);
  const downlinePageSize = 10;
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const search = async (forcedQuery = query, nextPage = 1) => {
    setLoading(true);
    setError("");
    try {
      const trimmed = String(forcedQuery || "").trim();
      const res = await adminApi.getTeamManagement(
        trimmed
          ? { q: trimmed, page: nextPage, pageSize: paging.pageSize }
          : { page: nextPage, pageSize: paging.pageSize },
      );
      if (res?.users) {
        setUserList(res.users);
        setPaging((prev) => ({
          ...prev,
          page: res.page || nextPage,
          pageSize: res.pageSize || prev.pageSize,
          total: res.total || 0,
        }));
        setData(null);
      } else {
        setData(res);
        setDownlinePage(1);
      }
    } catch (err) {
      setError(err?.response?.data?.error || "Failed to load team details");
      setData(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    search("", 1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <h2>Team Management</h2>
      <div className="row" style={{ marginBottom: 12 }}>
        <input
          placeholder="Search user by name/email"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
        <button className="btn-primary" onClick={search} disabled={loading}>
          {loading ? "Searching..." : "Search"}
        </button>
      </div>
      {error ? <div className="error">{error}</div> : null}

      {!data && userList.length > 0 ? (
        <div className="card" style={{ marginBottom: 12 }}>
          <h3>Select User</h3>
          <div className="table-wrap">
            <table>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {userList.map((user) => (
                  <tr key={user.id}>
                    <td>{user.name}</td>
                    <td>{user.email}</td>
                    <td>{user.isActive ? "Active" : "Inactive"}</td>
                    <td>
                      <button
                        className="btn-primary"
                        onClick={() => search(user.email, 1)}
                      >
                        View Team
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <Pagination
            page={paging.page}
            pageSize={paging.pageSize}
            total={paging.total}
            onPageChange={(nextPage) => search("", nextPage)}
          />
        </div>
      ) : null}

      {data ? (
        <>
          <div className="row" style={{ marginBottom: 12 }}>
            <div className="card">Total Team Size: {data.totalTeamSize || 0}</div>
            <div className="card">Team Earnings: {(data.teamEarnings || 0).toFixed(2)}</div>
          </div>

          <div className="card" style={{ marginBottom: 12 }}>
            <h3>Level-wise Distribution</h3>
            <div className="row">
              {(data.levelWiseDistribution || []).map((entry) => (
                <div className="card" key={entry.level}>
                  Level {entry.level}: {entry.count}
                </div>
              ))}
            </div>
          </div>

          <div className="card">
            <h3>Downline Details</h3>
            <div className="table-wrap">
              <table>
                <thead>
                  <tr>
                    <th>Level</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {(data.downlineDetails || [])
                    .slice(
                      (downlinePage - 1) * downlinePageSize,
                      downlinePage * downlinePageSize,
                    )
                    .map((member) => (
                    <tr key={`${member.id}-${member.depth}`}>
                      <td>{member.depth}</td>
                      <td>{member.name}</td>
                      <td>{member.email}</td>
                      <td>{member.isActive ? "Active" : "Inactive"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <Pagination
              page={downlinePage}
              pageSize={downlinePageSize}
              total={(data.downlineDetails || []).length}
              onPageChange={(nextPage) => setDownlinePage(nextPage)}
            />
          </div>
        </>
      ) : null}
    </div>
  );
}
